import { safeKey } from './budgetHierarchyUtils';

export const VALUE_EPSILON = 0.0001;

export const isSameAmount = (a, b) => Math.abs((Number(a) || 0) - (Number(b) || 0)) < VALUE_EPSILON;

export const buildLineKey = (customerNum, showroomNum, category, productNum, month) => [
    safeKey(customerNum),
    safeKey(showroomNum !== null && showroomNum !== undefined && showroomNum !== '' ? showroomNum : customerNum),
    safeKey(category),
    safeKey(productNum),
    safeKey(month),
].join('|');
